import {store} from "@davstack/store";
import {IMarriageNOC} from "../types";
import {getCompletedNocsRequest, getPendingNocsRequest, searchMarriageNocsRequest} from "../services/marriageNoc/marriageNoc.api";
import {createCSStore} from "./newStores";

type MarriageNOCStoreType = {
  pendingNOCs: IMarriageNOC[];
  completedNOCs: IMarriageNOC[];
  isLoadingPending: boolean;
  isLoadingCompleted: boolean;
}

export const marriageNOCStore = createCSStore("MarriageNOCStore")
  .state<MarriageNOCStoreType>({
    pendingNOCs: [],
    completedNOCs: [],
    isLoadingPending: false,
    isLoadingCompleted: false
  })
  .actions((store: { 
    pendingNOCs: { set: (value: IMarriageNOC[]) => void },
    completedNOCs: { set: (value: IMarriageNOC[]) => void },
    isLoadingPending: { set: (value: boolean) => void },
    isLoadingCompleted: { set: (value: boolean) => void }
  }) => ({
    fetchPendingNOCs: async () => {
      store.isLoadingPending.set(true);
      try {
        const response = await getPendingNocsRequest();
        const pendingNOCs = response.response.data
        store.pendingNOCs.set(pendingNOCs);
      } catch (error) {
        console.error('Error fetching pending NOCs:', error);
      } finally {
        store.isLoadingPending.set(false);
      }
    },
    fetchCompletedNOCs: async () => {
      store.isLoadingCompleted.set(true);
      try {
        const response = await getCompletedNocsRequest();
        const completedNOCs = response.response.data
        store.completedNOCs.set(completedNOCs);
      } catch (error) {
        console.error('Error fetching completed NOCs:', error);
      } finally {
        store.isLoadingCompleted.set(false);
      }
    },
    searchMarriageNoc: async (search: string) => {
      store.isLoadingCompleted.set(true);
      store.pendingNOCs.set([]);
      store.completedNOCs.set([]);
      try {
        const response = await searchMarriageNocsRequest(search);
        const completedResults = response.response.data
        store.completedNOCs.set(completedResults);
      } catch (error) {
        console.error('Error searching marriage NOCs:', error);
      } finally {
        store.isLoadingCompleted.set(false);
      }
    }
  })); 